"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AlertComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AlertComponent, _Component);

  var _super = _createSuper(AlertComponent);

  function AlertComponent() {
    var _this$props$isVisible;

    var _this;

    (0, _classCallCheck2.default)(this, AlertComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timeout", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isVisible: (_this$props$isVisible = _this.props.isVisible) !== null && _this$props$isVisible !== void 0 ? _this$props$isVisible : true,
      isVisibleFor: _this.props.isVisibleFor
    });
    return _this;
  }

  (0, _createClass2.default)(AlertComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.state.isVisible && this.state.isVisibleFor) {
        clearTimeout(this.timeout);
        this.timeout = window.setTimeout(function () {
          return _this2.setState({
            isVisible: false
          }, function () {
            if (_this2.props.onTimeoutEnd) {
              _this2.props.onTimeoutEnd();
            }
          });
        }, this.state.isVisibleFor);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isVisible !== prevProps.isVisible && this.props.isVisible) {
        this.setState({
          isVisible: this.props.isVisible
        });
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        isVisible: false
      });

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          messageType = _this$props.messageType,
          sticky = _this$props.sticky,
          children = _this$props.children,
          message = _this$props.message,
          renderHTML = _this$props.renderHTML,
          _this$props$showClose = _this$props.showCloseButton,
          showCloseButton = _this$props$showClose === void 0 ? true : _this$props$showClose;
      var isVisible = this.state.isVisible;

      if (messageType === null) {
        return null;
      }

      var type, defaultMessage;

      switch (messageType) {
        case 'error':
          type = 'danger';
          defaultMessage = 'Changes could not be applied';
          break;

        case 'success':
          type = 'success';
          defaultMessage = 'Changes applied successfully!';
          break;

        default:
          type = messageType !== null && messageType !== void 0 ? messageType : '';
          defaultMessage = '';
      }

      var attributes = {
        role: 'alert',
        className: "alert-notification alert alert-".concat(type, " box--alert box__pad")
      };
      if (sticky) attributes.className += ' sticky-top';
      return (0, _preact.h)("div", (0, _extends2.default)({}, !isVisible && {
        style: {
          display: 'none'
        }
      }, attributes), Array(children).toString() !== '' ? children : (0, _preact.h)("div", {
        dangerouslySetInnerHTML: renderHTML && message ? {
          __html: String(message)
        } : undefined
      }, message !== null && message !== void 0 ? message : defaultMessage), showCloseButton && (0, _preact.h)(_Close.default, {
        className: "alert-notification__close",
        onClick: function onClick() {
          return _this3.onClose();
        }
      }));
    }
  }]);
  return AlertComponent;
}(_preact.Component);

var _default = AlertComponent;
exports.default = _default;